import PropTypes from "prop-types";
import { idPropType } from "./id-prop-type";

export const reviewCoverPhotosPropType = PropTypes.shape({ id: idPropType });

export const reviewsCoverPhotosPropType = PropTypes.arrayOf(reviewCoverPhotosPropType);
